<template>
  <v-container class="fill-height">
    <v-row dense class="mb-2">
      <v-col cols="12">
        <v-card flat color="transparent">
          <v-card-title class="pa-0">
            <h5 class="text-h5 font-weight-bold primary--text">Consola de Logística</h5>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="fill-height mt-0">
      <v-col cols="12">
        <v-card rounded="lg" elevation="0" border class="fill-height overflow-hidden">
          <v-card-text class="pa-0 fill-height">
            <v-row no-gutters class="fill-height">
              <!-- Sidebar -->
              <v-col cols="12" sm="3" :md="mini ? '1' : '2'" class="border-right grey lighten-4">
                <v-list dense nav class="pa-2 grey lighten-4">
                  <v-list-item class="px-2 mb-4">
                    <v-list-item-avatar v-if="!mini">
                      <v-icon color="primary" large>mdi-truck-delivery</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content v-if="!mini">
                      <v-list-item-title class="font-weight-bold">Opciones</v-list-item-title>
                      <v-list-item-subtitle>Logística</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-btn icon @click.stop="mini = !mini" class="d-none d-sm-flex">
                      <v-icon>{{ mini ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
                    </v-btn>
                  </v-list-item>

                  <v-divider class="mb-2"></v-divider>

                  <v-list-item-group v-model="selectedItem" color="primary">
                    <v-list-item :value="0" class="rounded-lg mb-1">
                      <v-list-item-icon>
                        <v-icon>mdi-truck</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Guías asesores</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item :value="1" class="rounded-lg mb-1">
                      <v-list-item-icon>
                        <v-icon>mdi-qrcode</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Gestión QR's</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>

              <!-- Main Content Area -->
              <v-col cols="12" sm="9" :md="mini ? '11' : '10'" class="pa-4 bg-white overflow-y-auto logistic-content">
                <div v-if="selectedItem == 0" class="fade-transition">
                  <Shipments />
                </div>
                <div v-else-if="selectedItem == 1" class="fade-transition">
                  <ManagementQR />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//Vuex
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
//components
import Shipments from "@/components/logistic/Shipments.vue";
import ManagementQR from "@/components/logistic/ManagementQR.vue";
export default {
  components: {
    Shipments,
    ManagementQR,
  },
  data: () => ({
    isVisible: false,

    selectedItem: 0,
    drawer: true,
    mini: false,
  }),
  async mounted() {},
  methods: {
    selectItem(index) {
      this.selectedItem = index;
      // Aquí puedes realizar cualquier otra acción necesaria cuando se selecciona un elemento
    },
    toggleDrawer() {
      this.drawer = !this.drawer; // Alterna el estado del drawer
    },
  },
  watch: {},
};
</script>
<style scoped>
.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.bg-white {
  background-color: white !important;
}

.logistic-content {
  min-width: 0;
  overflow-x: auto;
}

.fade-transition {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}

.pointer-on-hover:hover {
  cursor: pointer;
}
</style>
